module.exports = __webpack_public_path__ + "static/img/baguetteman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/baguetteman.jpg
// module id = GUl2
// module chunks = 1